(() => {
  function initOne(root) {
    const carouselListSmall = root.querySelector(".myapp-carousel-list-small");
    const prevButtonSmall = root.querySelector(".myapp-nav-prev-small");
    const nextButtonSmall = root.querySelector(".myapp-nav-next-small");
    const scrollbarSmall = root.querySelector(".myapp-custom-scrollbar-small");
    const scrollbarDragSmall = root.querySelector(".myapp-custom-scrollbar-drag-small");

    if (!carouselListSmall || !prevButtonSmall || !nextButtonSmall || !scrollbarSmall || !scrollbarDragSmall) {
      return;
    }

    let movedSmall = false;
    let isDraggingSmall = false;
    let dragStartXSmall = 0;
    let scrollStartXSmall = 0;

    let isScrollbarDraggingSmall = false;
    let startXSmall = 0;
    let startScrollLeftSmall = 0;

    function updateNavButtonsVisibilitySmall() {
      if (window.innerWidth <= 600) {
        prevButtonSmall.style.display = "none";
        nextButtonSmall.style.display = "none";
      } else {
        prevButtonSmall.style.display = "none";
        nextButtonSmall.style.display = "flex";
      }
    }

    function showPrevButtonSmall() {
      if (window.innerWidth > 600) {
        prevButtonSmall.style.display = "flex";
      }
    }

    function updateScrollbarSmall() {
      const scrollWidth = carouselListSmall.scrollWidth;
      const clientWidth = carouselListSmall.clientWidth;
      const scrollLeft = carouselListSmall.scrollLeft;
      const scrollbarWidth = scrollbarSmall.clientWidth;

      if (scrollWidth <= clientWidth) {
        scrollbarDragSmall.style.width = "100%";
        scrollbarDragSmall.style.transform = "translateX(0px)";
        return;
      }

      const dragWidth = Math.max((clientWidth / scrollWidth) * scrollbarWidth, 30);
      const dragLeft = (scrollLeft / (scrollWidth - clientWidth)) * (scrollbarWidth - dragWidth);

      scrollbarDragSmall.style.width = dragWidth + "px";
      scrollbarDragSmall.style.transform = "translateX(" + dragLeft + "px)";
    }

    function onResize() {
      updateNavButtonsVisibilitySmall();
      updateScrollbarSmall();
    }

    updateNavButtonsVisibilitySmall();
    updateScrollbarSmall();

    window.addEventListener("resize", onResize);

    nextButtonSmall.addEventListener("click", () => {
      carouselListSmall.scrollBy({ left: -300, behavior: "smooth" });
      showPrevButtonSmall();
      updateScrollbarSmall();
    });

    prevButtonSmall.addEventListener("click", () => {
      carouselListSmall.scrollBy({ left: 300, behavior: "smooth" });
      showPrevButtonSmall();
      updateScrollbarSmall();
    });

    carouselListSmall.addEventListener("scroll", () => {
      showPrevButtonSmall();
      updateScrollbarSmall();
    });

    carouselListSmall.addEventListener("mousedown", (e) => {
      isDraggingSmall = true;
      movedSmall = false;
      dragStartXSmall = e.pageX;
      scrollStartXSmall = carouselListSmall.scrollLeft;
      carouselListSmall.style.cursor = "grabbing";
      e.preventDefault();
    });

    document.addEventListener("mouseup", () => {
      isDraggingSmall = false;
      carouselListSmall.style.cursor = "grab";
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDraggingSmall) return;

      const dx = e.pageX - dragStartXSmall;
      if (Math.abs(dx) > 5) movedSmall = true;

      carouselListSmall.scrollLeft = scrollStartXSmall - dx;
      showPrevButtonSmall();
      updateScrollbarSmall();
    });

    root.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", (e) => {
        if (movedSmall) e.preventDefault();
      });
    });

    scrollbarDragSmall.addEventListener("mousedown", (e) => {
      isScrollbarDraggingSmall = true;
      startXSmall = e.pageX;
      startScrollLeftSmall = carouselListSmall.scrollLeft;
      document.body.style.userSelect = "none";
    });

    document.addEventListener("mouseup", () => {
      isScrollbarDraggingSmall = false;
      document.body.style.userSelect = "auto";
    });

    document.addEventListener("mousemove", (e) => {
      if (!isScrollbarDraggingSmall) return;

      const dx = e.pageX - startXSmall;
      const scrollWidth = carouselListSmall.scrollWidth - carouselListSmall.clientWidth;
      const scrollbarWidth = scrollbarSmall.clientWidth - scrollbarDragSmall.offsetWidth;

      if (scrollbarWidth <= 0) return;

      const scrollDelta = (dx / scrollbarWidth) * scrollWidth;
      carouselListSmall.scrollLeft = startScrollLeftSmall + scrollDelta;

      showPrevButtonSmall();
      updateScrollbarSmall();
    });

    scrollbarSmall.addEventListener("mousedown", (e) => {
      if (e.target === scrollbarDragSmall) return;

      const rect = scrollbarSmall.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const dragCenter = scrollbarDragSmall.offsetLeft + scrollbarDragSmall.offsetWidth / 2;

      const scrollWidth = carouselListSmall.scrollWidth - carouselListSmall.clientWidth;
      const scrollbarWidth = scrollbarSmall.clientWidth - scrollbarDragSmall.offsetWidth;

      if (scrollbarWidth <= 0) return;

      const delta = ((clickX - dragCenter) / scrollbarWidth) * scrollWidth;
      carouselListSmall.scrollBy({ left: delta, behavior: "smooth" });

      showPrevButtonSmall();
      updateScrollbarSmall();
    });
  }

  function initAll() {
    document.querySelectorAll("[data-collection-carousel-small]").forEach((root) => {
      if (root.dataset.initialized === "true") return;
      root.dataset.initialized = "true";
      initOne(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
